import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { UserService } from 'src/app/_services';
import { GeneralUserData } from 'src/app/_models';
import { BaseComponent } from 'src/app/_base/base.component';

@Component({
  selector: 'app-whatsapp-student-info',
  templateUrl: './whatsapp-student-info.component.html',
  styleUrls: ['./whatsapp-student-info.component.scss']
})
export class WhatsappStudentInfoComponent extends BaseComponent implements OnInit, OnChanges {
  @Input()
  studentId: string;
  studentInfo: GeneralUserData = null;
  isActive: boolean = false;
  constructor(private userService: UserService) {
    super();
  }

  ngOnInit() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.studentId !== undefined) this.getStudentInfo();
  }
  getStudentInfo(): void {
    if (this.studentId !== null) {
      this.isActive = true;
      this.userService.getUserById(this.studentId).subscribe(
        (data: GeneralUserData) => {
          this.studentInfo = data;
          this.isActive = false;
        },
        () => {
          this.isActive = false;
        }
      );
    }
  }
  getUserImage(userImage: string): string {
    return userImage !== null && this.getImage(userImage) ? this.getImage(userImage) : './assets/Images/users/default-user.jpg';
  }
  goTo(pageName: string): void {
    if (pageName === 'Facebook') window.open(this.studentInfo.facebookUrl, '_blank');
    else if (pageName === 'Twitter') window.open(this.studentInfo.twitterUrl, '_blank');
    else if (pageName === 'Linkedin') window.open(this.studentInfo.linkedinUrl, '_blank');
    else if (pageName === 'Email') window.open('mailto:' + this.studentInfo.email);
  }
}
